export enum UploadStatus {
  NotStarted = 'NOT_STARTED',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS',
  Failed = 'FAILED',
  Cancelled = 'CANCELLED',
}

export interface UploadRow {
  name: string;
  size: number;
  status: UploadStatus;
  /** 0-100. */
  progress: number;
  error?: string;
}
